import { IMessage } from 'APP/model/message/messageModel.types';
import bus from 'APP/packages/bus';
import Entities from 'STORE';

import { addMessagesToStore } from './addMessagesToStore';
import { handleScrollPosition } from './handleScrollPosition';

export async function handleNewMessages(
  messages: IMessage[],
  previousMessageTs: number
): Promise<boolean> {
  if (messages.length === 0) {
    return false;
  }

  const groupId = messages[0].groupId;
  const group = Entities.GroupsStore.getGroupById(groupId);
  bus.messaging.broadcastMessagesChanges(groupId);

  if (!group || group.isFake || (!group.messagesStore.isLoadedLastMessages && previousMessageTs)) {
    return false;
  }

  if (
    group !== Entities.GroupsStore.activeGroup &&
    (group.messagesStore.lastMessage?.serverTime || 0) < previousMessageTs
  ) {
    group.messagesStore.setLoadedLastMessages(false);
    return false;
  }

  await addMessagesToStore(group, messages, previousMessageTs);

  if (group === Entities.GroupsStore.activeGroup) {
    handleScrollPosition();
  }

  return true;
}
